export const environment = {
  showAds: true,
  basePhotoUrl: "/api/photo/s3/"
};
